import bowser from 'bowser';

export function isTouchDevice() {
  return 'ontouchstart' in document.documentElement;
}

export function isFirefox() {
  return bowser.firefox;
}

export function isSafari() {
  return bowser.safari;
}

export function isIEorEdge() {
  return bowser.msedge || bowser.msie;
}

export function isIENotEdge() {
  return bowser.msie;
}

export function isEdge() {
  return bowser.msedge;
}

export function isIOS() {
  return bowser.ios;
}

export function supportsSvgCssAnimation() {
  // Should be able to allow msedge once this is fixed:
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6493460/
  return !isIEorEdge();
}

export function supportsDownloadAttribute() {
  return 'download' in document.createElement('a');
}
